import React from "react";
import styles from "./AgeingBucket.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import { HiOutlineDocumentText } from "react-icons/hi2";

// Example ageing data
const ageingData = [
  { label: "1–15 days", count: 10, color: "#f8bcbc" },
  { label: "16–30 days", count: 5, color: "#c5c8ff" },
  { label: "31–45 days", count: 7, color: "#aee1c9" },
  { label: "45+ days", count: 3, color: "#d8cc9f" },
];

const total = ageingData.reduce((sum, item) => sum + item.count, 0);

const AgeingBucket = () => {
  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <HeadingAndIcon
          icon={<HiOutlineDocumentText />}
          heading="Ageing bucket for overdue invoices"
        />
      </div>

      <div className={styles.graphWrapper}>
        <svg viewBox="0 0 36 36" className={styles.donut}>
          {
            ageingData.reduce(
              (acc, item) => {
                const prev = acc.offset;
                const val = (item.count / total) * 100;
                acc.offset += val;
                acc.segments.push(
                  <circle
                    key={item.label}
                    className={styles.segment}
                    r="15.9155"
                    cx="18"
                    cy="18"
                    fill="transparent"
                    stroke={item.color}
                    strokeWidth="4"
                    strokeDasharray={`${val} ${100 - val}`}
                    strokeDashoffset={100 - prev}
                  />
                );
                return acc;
              },
              { offset: 0, segments: [] }
            ).segments
          }
        </svg>

        <div className={styles.valueLabels}>
          {ageingData.map((item, index) => (
            <div
              key={item.label}
              className={styles.valueLabel}
              style={{ color: item.color }}
            >
              <span className={styles.count}>{item.count}</span>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.legend}>
        {ageingData.map((item) => (
          <div className={styles.dotRow} key={item.label}>
            <span
              className={styles.dot}
              style={{ backgroundColor: item.color }}
            ></span>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AgeingBucket;
